import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import { createNewPatient } from "../../services/api";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import Alert from "../../assets/images/alert.png";

const IntakeFormPage13: React.FC = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [uuidValue, setUuidValue] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState<string>("");
  const [phoneError, setPhoneError] = useState<string>("");
  const navigate = useNavigate();
  const [err, setErr] = useState<string>("");
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  },[]);

  useEffect(() => {
    const completeIntakeStep9 = localStorage.getItem("complete-intake-step9");
    if (completeIntakeStep9) {
      navigate("/complete-intake/step-10", { replace: true });
    } else {
      navigate("/complete-intake/step-9", { replace: true });
    }
  }, []);

  const isValidEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const isValidPhone = (phone: string): boolean => {
    const phonePattern = /^\d{10}$/;
    return phonePattern.test(phone);
  };


  const handleNext = async () => {
    if (!isValidEmail(email)) {
      setEmailError(
        "Invalid email address. Please enter a valid email address."
      );
      return;
    } else {
      setEmailError("");
    }

    const cleanedPhone = phone.replace(/\D/g, "");
    if (!isValidPhone(cleanedPhone)) {
      setPhoneError(
        "Invalid phone number. Please enter a 10-digit phone number."
      );
      return;
    } else {
      setPhoneError("");
    }

    if (firstName && lastName && email && phone) {
      localStorage.setItem(
        "firstName",
        JSON.stringify({ key: "firstName", value: firstName })
      );
      localStorage.setItem(
        "lastName",
        JSON.stringify({ key: "lastName", value: lastName })
      );
      localStorage.setItem(
        "email",
        JSON.stringify({ key: "email", value: email })
      );
      localStorage.setItem(
        "phone",
        JSON.stringify({ key: "phone", value: phone })
      );
      localStorage.setItem(
        "isSubscribed",
        JSON.stringify({ key: "isSubscribed", value: isSubscribed })
      );
      localStorage.setItem(
        "fullName",
        JSON.stringify({ key: "firstName", value: firstName + " " + lastName })
      );

      navigate("/complete-intake/step-11");
      localStorage.setItem("complete-intake-step10", "true");

      // try {
      //   setLoading(true);
      //   const productCategory = "GLP1";

      //   const appointmentResponse = await createNewPatient(
      //     firstName,
      //     lastName,
      //     email,
      //     phone,
      //     isSubscribed,
      //     productCategory,
      //     uuidValue
      //   );

      //   const data = await appointmentResponse.json();

      //   if (!appointmentResponse.ok) {
      //     setErr(data?.error || "Failed to create patient.");
      //     throw new Error(data?.error || "Failed to create patient.");
      //   }

      //   if (data && data.user && data.user.length > 0) {
      //     const patientData = data.user[0];
      //     const disableAddress = data.disable_address || false;

      //     localStorage.setItem(
      //       "disable_address",
      //       JSON.stringify({ key: "disable_address", value: disableAddress })
      //     );

      //     if (patientData.addressLineOne)
      //       localStorage.setItem(
      //         "addressLine1",
      //         JSON.stringify({
      //           key: "addressLine1",
      //           value: patientData.addressLineOne,
      //         })
      //       );
      //     if (patientData.addressLineTwo)
      //       localStorage.setItem(
      //         "addressLine2",
      //         JSON.stringify({
      //           key: "addressLine2",
      //           value: patientData.addressLineTwo,
      //         })
      //       );
      //     if (patientData.city)
      //       localStorage.setItem(
      //         "city",
      //         JSON.stringify({ key: "city", value: patientData.city })
      //       );
      //     if (patientData.state)
      //       localStorage.setItem(
      //         "state",
      //         JSON.stringify({ key: "state", value: patientData.state })
      //       );
      //     if (patientData.zipCode)
      //       localStorage.setItem(
      //         "zip",
      //         JSON.stringify({ key: "zip", value: patientData.zipCode })
      //       );

      //     if (patientData.state) {
      //       localStorage.setItem(
      //         "state",
      //         JSON.stringify({
      //           key: "state",
      //           value: patientData.state,
      //         })
      //       );
      //     }
      //   }
      //   navigate("/complete-intake/step-11");
      //   localStorage.setItem("complete-intake-step10", "true");
      // } catch (error: unknown) {
      //   if (error instanceof Error) {
      //     setErr(error.message);
      //   } else {
      //     setErr("An unexpected error occurred.");
      //   }
      //   console.error("Error adding patient:", error);
      // } finally {
      //   setLoading(false);
      // }
    }
  };
  useEffect(() => {
    const savedFirstName = localStorage.getItem("firstName");
    const savedLastName = localStorage.getItem("lastName");
    const savedEmail = localStorage.getItem("email");
    const savedPhone = localStorage.getItem("phone");
    const savedIsSubscribed = localStorage.getItem("isSubscribed");

    if (savedFirstName) {
      const parsedFirstName = JSON.parse(savedFirstName);
      setFirstName(parsedFirstName.value);
    }
    if (savedLastName) {
      const parsedLastName = JSON.parse(savedLastName);
      setLastName(parsedLastName.value);
    }
    if (savedEmail) {
      const parsedEmail = JSON.parse(savedEmail);
      setEmail(parsedEmail.value);
    }
    if (savedPhone) {
      const parsedPhone = JSON.parse(savedPhone);
      const raw = parsedPhone.value.replace(/\D/g, "");
      const cleaned = raw.length === 11 && raw.startsWith("1") ? raw.slice(1) : raw;
      setPhone(formatPhoneNumber(cleaned));
    }
    if (savedIsSubscribed) {
      const parsedIsSubscribed = JSON.parse(savedIsSubscribed);
      setIsSubscribed(parsedIsSubscribed.value);
    }
  }, []);

  const styles = {
    container: {
      maxWidth: "500px",
      margin: "0 auto",
    },
    content: {
      marginTop: "20px",
    },
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      marginBottom: "20px",
    },
    input: {
      width: "560px",
      height: "52px",
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #D9D9D9",
      borderRadius: "154px",
      background: "#FFF",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },

    checkboxContainer: {
      display: "flex",
      alignItems: "center",
    },
    loader: {
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #3498db",
      borderRadius: "50%",
      width: "20px",
      height: "10px",
      animation: "spin 1s linear infinite",
    },
  };

  const formatPhoneNumber = (value: string): string => {
    const cleaned = ("" + value).replace(/\D/g, "");
    if (cleaned.length > 10) {
      setPhoneError("Phone number cannot exceed 10 digits");
      return value;
    } else {
      setPhoneError("");
    }

    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6,
        10
      )}`;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length <= 10) {
      setPhone(formatPhoneNumber(value));
    }
  };
  const step = 9;

  const inputError = (errorMessage: string) => {
    if (!errorMessage) return null;
    return (
      <div className="checkout-state-error" style={{ marginTop: "20px" }}>
        <img src={Alert} alt="state-error" width={"16px"} height={"15px"} />
        <p className="checkout-state-error-text">{errorMessage}</p>
      </div>
    );
  };

  return (
    <PageWrapper>
      <div className="signup-page-container">
        <ProgressBar progress={90} step={step} />
        <div className="signup-content">
          <p className="signup-intro-info">
            Amazing! You’ve been pre-approved as an ideal candidate for{" "}
            <span className="signup-intro-special-words">
              Claya&apos;s GLP-1 wellness
            </span>{" "}
            journey.
          </p>
          <p className="signup-intro-para-second" style={{ marginBottom: 30 }}>
            To receive your tailored medication plan and begin your wellness
            journey with Claya, enter the following contact information.
          </p>

          <div style={styles.inputContainer}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              First Name
            </p>
            <input
              type="text"
              value={firstName}
              disabled={!!firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="First name"
              className="input-fields"
            />
          </div>

          <div style={styles.inputContainer}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              Last Name
            </p>
            <input
              type="text"
              disabled={!!lastName}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Last name"
              className="input-fields"
            />
          </div>

          <div style={styles.inputContainer}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              Email
            </p>
            <input
              type="email"
              value={email}
              disabled={!!email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError("");
                setErr("");
              }}
              placeholder="Email"
              className="input-fields"
            />
            {emailError && inputError(emailError)}
          </div>

          <div style={styles.inputContainer}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              Phone
            </p>
            <input
              type="tel"
              value={phone}
              onChange={handleChange}
              placeholder="Phone number: (XXX) XXX-XXXX"
              className="input-fields"
            />
            {phoneError && inputError(phoneError)}
          </div>

          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={isSubscribed}
              onChange={() => setIsSubscribed(!isSubscribed)}
              style={{ cursor: "pointer" }}
            />
            <label className="checkboxLabel">
              By subscribing, you agree to receive Account Notification text
              messages at the phone number provided. Reply STOP to cancel.
              Message and data rates may apply.
            </label>
          </div>
          {err && inputError(err)}
          <button
            onClick={handleNext}
            disabled={
              !(firstName && lastName && email && phone && isSubscribed) ||
              loading
            }
            className="next-btn"
            style={{
              backgroundColor:
                loading ||
                !(firstName && lastName && email && phone && isSubscribed)
                  ? "#d3d3d3"
                  : "#0c3972",
            }}
          >
            {loading ? "Loading..." : "Continue →"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage13;
